module.exports = __webpack_public_path__ + "static/media/ICT-22.6185598f.jpg";